import { render } from "./page-stock.vue?vue&type=template&id=c96c7208&ts=true"
import script from "./page-stock.vue?vue&type=script&lang=ts"
export * from "./page-stock.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vladdof/Documents/company-quotes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__